export enum ROUTEPATHS {
  HOME = '/',
  SIGNUP = '/signup',
  CHOOSEUSERNAME= 'choose-username',
  COMMUNITY = 'Community',
  USER = 'User',
  CLIENT = 'Client',
  SIGNIN = '/login',
  TEST = '/test',
  TEST2 = '/test2',
  TEST3 = '/test3',
  CONTACT_US = '/contactUs',

  CONTEST = 'Contest',
  CONTEST_BRIEF = 'Brief',
  CONTEST_INSPIRATIONS = 'inspirations',
  CREATE_INSPIRATION = 'inspirations/new',
  CONTEST_AWARDS = 'Awards',
  CONTEST_GALLERY = 'Gallery',
  CONTEST_UPLOAD = 'Upload',

  DESIGN_DETAILS = '/design-details',

  INFO_COMPANIES = 'companies',
  INFO_CREATIVES = 'creatives',
  INFO_CREATIVES_ADDITIONAL = 'creatives-additional-info',
  INFO_CREATIVES_DREAMTEAM = 'creatives-dream-team',
  INFO_CREATIVES_ABOUT = 'about-us',
  INFO_CREATIVES_PARTNERS = 'partners',

  COMPANIES_MARKET = 'market',
  COMPANIES_CASE_STUDIES = 'case-studies',

  COMMUNITY_PROFILE = 'Profile',
  COMMUNITY_PROFILE_PREVIEW = 'profile-preview',
  COMMUNITY_PROFILE_EDITABLE = 'profile-editable',
  COMMUNITY_PORTFOLIO = 'Portfolio',
  COMMUNITY_DESIGN = 'design',
  COMMUNITY_SEARCH = '/community-search',

  CLIENT_CONTESTS = 'client-contests',

  DESIGNER_INSPIRATIONS = 'Inspiration',
  DESIGNER_CONTEST_PORTFOLIO = 'contest-portfolio',
  USER_FAVORITES = 'user-favorites',
  USER_AMBASSADOR = 'ambassador',
  USER_AWARDS = 'Awards',
  USER_BADGE = 'Badge',

  LIBRARY = 'library',
  TYPOGRAPHY = 'typography',
  IMAGES = 'images',
  BUTTONS = 'buttons',
  CARDS = 'cards',
  FORMS = 'forms',
  COMPONENTS = 'components',
}
